module.exports = __webpack_public_path__ + "static/img/onetokyo.2c6b2e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tmf/onetokyo.svg
// module id = M7wk
// module chunks = 1